import { FC } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

import { Alert, Heading, Text } from "@livechat/design-system-react-components";

import Role from "constants/role";
import { trackEngagement } from "helpers/analytics";
import { getNextPlanHash } from "helpers/subscription-plans";
import { AgentsRoutes } from "routes/agents/constants";
import { selectLoggedInAgentPermission } from "store/entities/agents";
import { PlanLimitExceededSource, selectCurrentSubscriptionPlan } from "store/entities/subscriptions";

import { SubscriptionRoutes } from "./constants";

interface IProps {
  source?: PlanLimitExceededSource;
}

const UpsellAlert: FC<IProps> = ({ source }) => {
  const history = useHistory();
  const agentRole = useSelector(selectLoggedInAgentPermission);
  const currentPlan = useSelector(selectCurrentSubscriptionPlan);
  const isViewer = agentRole === Role.Viewer;
  const isAdmin = agentRole === Role.Owner;

  if (isViewer) {
    return null;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleAlertAction = () => {
    history.push(isAdmin ? `${SubscriptionRoutes.Plans}/${getNextPlanHash(currentPlan)}` : AgentsRoutes.Agents);
    trackEngagement("Plan limit exceeded: upsell alert CTA clicked", undefined, { agentRole, source });
  };

  return (
    <Alert
      data-testid="upsell-alert"
      primaryButton={{
        label: isAdmin ? "Upgrade plan" : "Find admin",
        handleClick: handleAlertAction,
      }}
      css={{ maxWidth: "800px" }}
    >
      <Heading size="xs">Plan limit reached</Heading>
      <Text>
        {isAdmin
          ? "Upgrade now for full feature capabilities and even better ticket resolution experience."
          : "Ask any admin to upgrade now for full feature capabilities and even better ticket resolution experience."}
      </Text>
    </Alert>
  );
};

export { UpsellAlert };
